import React from "react";
import Icon from "components/AppIcon";

const metrics = [
  { label: "Subject Price", value: "$385,000", sub: "Listed", icon: "Home", color: "text-primary", bg: "bg-primary/10" },
  { label: "AVM Estimate", value: "$389,000", sub: "+1.0% vs list", icon: "Cpu", color: "text-secondary", bg: "bg-secondary/10" },
  { label: "Avg Comp Price", value: "$374,400", sub: "5 comparables", icon: "BarChart2", color: "text-foreground", bg: "bg-muted" },
  { label: "Avg Adj. Value", value: "$370,100", sub: "After adjustments", icon: "TrendingUp", color: "text-primary", bg: "bg-primary/10" },
  { label: "Avg $/Sq Ft", value: "$151", sub: "Market avg", icon: "Maximize2", color: "text-foreground", bg: "bg-muted" },
  { label: "Avg DOM", value: "13 days", sub: "Comparables", icon: "Clock", color: "text-warning", bg: "bg-warning/10" },
];

export default function ValuationSummaryBar() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {metrics?.map((m) => (
        <div key={m?.label} className="card-base p-3 flex flex-col gap-1">
          <div className="flex items-center gap-2 mb-1">
            <div className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${m?.bg}`}>
              <Icon name={m?.icon} size={14} color={`var(--color-${m?.color?.replace("text-", "")})`} />
            </div>
            <span className="text-xs font-caption text-muted-foreground leading-tight">{m?.label}</span>
          </div>
          <div className={`font-mono-data text-base font-bold ${m?.color}`}>{m?.value}</div>
          <div className="text-xs font-caption text-muted-foreground">{m?.sub}</div>
        </div>
      ))}
    </div>
  );
}